import { createProductId } from 'helpers/createProductId'
import { TimeInterval, ScreenName } from 'root-constants'
import { ISubscription } from 'models/subscriptions.model'

export const enum GoogleAnalyticsAction {
  EVENT = 'event',
}

export const enum GoogleAnalyticsEvent {
  PAGE_VIEW = 'page_view',
  BEGIN_CHECKOUT = 'begin_checkout',
  ADD_TO_CART = 'add_to_cart',
  PURCHASE = 'purchase',
  FIRST_PAGE_COMPLETED = 'first_page_completed',
  ENTER_EMAIL_PAGE_COMPLETED = 'enter_email_page_completed',
  DOWNLOAD_BUTTON_PRESSED = 'download_button_press',
}

export const enum GoogleAnalyticsEventCategory {
  TRANSITION = 'transition',
}

class GoogleAnalyticsService {
  logPageView(location: string): void {
    window.gtag(GoogleAnalyticsAction.EVENT, GoogleAnalyticsEvent.PAGE_VIEW, {
      page_path: `/${location}`,
    })
  }

  logCheckoutStarted(subscriptions: ISubscription[]): void {
    window.gtag(
      GoogleAnalyticsAction.EVENT,
      GoogleAnalyticsEvent.BEGIN_CHECKOUT,
      {
        items: subscriptions.map(
          ({ periodName, periodQuantity, currentPrice }) => ({
            id: createProductId({
              periodName,
              periodQuantity,
              price: currentPrice,
            }),
            price: currentPrice,
          }),
        ),
      },
    )
  }

  logAddingToCart({
    periodName,
    periodQuantity,
    currentPrice,
  }: ISubscription): void {
    window.gtag(GoogleAnalyticsAction.EVENT, GoogleAnalyticsEvent.ADD_TO_CART, {
      items: [
        {
          id: createProductId({
            periodName,
            periodQuantity,
            price: currentPrice,
          }),
          price: currentPrice,
        },
      ],
    })
  }

  logPurchaseCompleted({
    subscriptionId,
    price,
    periodName,
    periodQuantity,
    currency,
    screenName,
  }: {
    subscriptionId: string
    price: number
    periodName: TimeInterval | null
    periodQuantity: number | null
    currency: string
    screenName: ScreenName
  }): void {
    window.gtag(GoogleAnalyticsAction.EVENT, GoogleAnalyticsEvent.PURCHASE, {
      event_label: screenName,
      transaction_id: subscriptionId,
      value: price,
      currency,
      items: [
        {
          id: createProductId({ periodName, periodQuantity, price }),
          price,
        },
      ],
    })
  }

  logFirstPageCompleted(): void {
    window.gtag(
      GoogleAnalyticsAction.EVENT,
      GoogleAnalyticsEvent.FIRST_PAGE_COMPLETED,
      {
        event_category: GoogleAnalyticsEventCategory.TRANSITION,
      },
    )
  }

  logEnterEmailPageCompleted(): void {
    window.gtag(
      GoogleAnalyticsAction.EVENT,
      GoogleAnalyticsEvent.ENTER_EMAIL_PAGE_COMPLETED,
      {
        event_category: GoogleAnalyticsEventCategory.TRANSITION,
      },
    )
  }

  logDownloadButtonPressed(): void {
    window.gtag(
      GoogleAnalyticsAction.EVENT,
      GoogleAnalyticsEvent.DOWNLOAD_BUTTON_PRESSED,
    )
  }
}

export const googleAnalyticsLogger = new GoogleAnalyticsService()
